module.exports = __webpack_public_path__ + "media/images/logos/simplyhired-b569d301eb3a247424c25c4d74931c13.svg";